import React, { useState } from 'react';
import OfferOverlayLink from 'core/modules/OfferOverlayLink/OfferOverlayLink';

import './CategoryMerchantOffers.scss';

function CategoryMerchantOffers({ offers = [], categoryName = '', merchantName = '' }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleOffers = () => {
    setIsExpanded(!isExpanded);
  };

  const getOffers = offers => (
    offers && offers.map(offer => (
      <div
        className="mn_offerItem"
        key={offer.id}
        data-test="category-merchant-offer"
      >
        <OfferOverlayLink offerId={offer.id} merchantId={offer.merchant.id} merchantName={offer.merchant.name}>
          <p className="mn_description" data-test="category-merchant-offer-description">
            {offer.description}
          </p>
          <p
            className="mn_expirationDate"
            data-test="category-merchant-offer-expiration-date"
          >
            <span>Valid through:</span> {offer.isOngoing ? 'Ongoing' : offer.expires}
          </p>
        </OfferOverlayLink>
      </div>
    ))
  );

  return (
    <div
      className="mn_merchantOffersWrap"
      data-test="merchant-offers-wrap"
    >
      <button
        className={`mn_offersToggle ${isExpanded ? 'mn_expanded' : ''}`}
        aria-expanded={isExpanded}
        title={`Toggle ${categoryName} offers for ${merchantName}`}
        onClick={toggleOffers}
        data-test="merchant-offers-toggle-button"
      >
        {`${offers.length} ${categoryName.toLowerCase()} offer${offers.length > 1 ? 's' : ''}`}
        <i aria-hidden="true" className="mn_toggleIcon" />
      </button>
      {isExpanded && getOffers(offers)}
    </div>
  );
}

export default CategoryMerchantOffers;
